module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-8000-with-gift-f70deada.png";